import { useEffect } from "react";
import { useSceneStore } from "@/state/useSceneStore";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useCameraTo } from "@/scene/cameras/useCameraTo";
import { cameraTargets } from "@/scene/cameras/cameraTargets";

export const Monitor = (): null => {
  const active = useSceneStore((s) => s.activeSection) === "monitor";
  const isMobile = useMediaQuery("(max-width: 992px)");
  const cameraTo = useCameraTo();

  useEffect(() => {
    let cancelled = false;
    if (!active || isMobile) return;
    void (async () => {
      if (cancelled) return;
      await cameraTo(cameraTargets.monitor, 1.1);
    })();
    return () => {
      cancelled = true;
    };
  }, [active, isMobile, cameraTo]);

  return null;
};
